import type { OptionId } from "@/components/interview/types";
import { setIntersection } from "@/lib/utils";

// A minimum of 1 is already represented by "has any" (selected_any_option).
export const MIN_SELECTED_OPTIONS_COUNT = 2;

export const isValidMinCount = (
  minCount: number,
  choiceCount: number
): boolean =>
  Number.isInteger(minCount) &&
  minCount >= MIN_SELECTED_OPTIONS_COUNT &&
  minCount <= choiceCount;

// With no choices, only the lower bound applies until the row is complete.
export const clampMinCount = ({
  minCount,
  choiceCount,
}: {
  minCount: number;
  choiceCount: number;
}): number => {
  const lowerBounded = Math.max(MIN_SELECTED_OPTIONS_COUNT, minCount);
  return choiceCount === 0
    ? lowerBounded
    : Math.min(lowerBounded, Math.max(MIN_SELECTED_OPTIONS_COUNT, choiceCount));
};

export const hasMinSelectedOptions = ({
  selectedOptionIds,
  options,
  minCount,
}: {
  selectedOptionIds: ReadonlySet<OptionId>;
  options: readonly OptionId[];
  minCount: number;
}): boolean =>
  setIntersection(new Set(options), selectedOptionIds).size >= minCount;
